import { FunctionComponent } from 'react'

type HandProps = {
	//
}

const Hand: FunctionComponent<HandProps> = () => (
	<div className="hand">
		<svg viewBox="0 0 30 38" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M26.3946 17.6088C25.459 17.258 24.7392 17.3986 24.2371 17.6916C24.2123 17.6171 24.184 17.5404 24.1515 17.4622C23.8714 16.7872 23.2911 16.0151 22.1363 15.6057L22.136 15.6056C21.0206 15.211 20.164 15.4939 19.5965 15.8997C19.5261 15.95 19.4607 16.0018 19.4 16.0539C19.3548 15.9633 19.3035 15.869 19.2452 15.7728C18.8693 15.1525 18.2013 14.4504 17.0599 14.1369C16.0306 13.8536 15.1494 14.2213 14.5636 14.6142C14.5455 14.6263 14.5278 14.6385 14.5102 14.6507V3.576C14.5102 3.01858 14.3555 2.26307 13.892 1.63287C13.4108 0.978736 12.6249 0.500579 11.4684 0.500001C10.3046 0.499419 9.5356 0.994746 9.07731 1.66066C8.63846 2.29832 8.51019 3.0515 8.51019 3.576V21.41C8.51019 17.4325 6.37544 14.9581 5.59704 14.2485C4.77068 13.4952 3.65424 13.1138 2.33618 13.3949C1.78704 13.5117 1.35065 13.7161 1.03673 14.0205C0.715844 14.3316 0.560408 14.7109 0.514916 15.1018C0.429194 15.8385 0.733007 16.6484 1.00753 17.2801C2.31828 20.2999 3.22695 24.6361 3.50368 26.6859C4.32672 32.7886 9.55339 37.4937 15.8817 37.5H15.8819C22.7738 37.5042 28.505 31.9886 28.5102 25.0764V25.076V21.1527L28.5102 21.1516L28.5107 21.1248C28.511 21.1027 28.5111 21.072 28.5105 21.0337C28.5092 20.9573 28.505 20.8502 28.4935 20.7207C28.4706 20.463 28.4182 20.1088 28.2988 19.7266C28.0607 18.9648 27.5345 18.0357 26.3946 17.6088Z"
				stroke="black"
			/>
		</svg>
	</div>
)

export default Hand
